export const SERVICE_INTERVAL_OPTIONS = [
    { weeks: 1, label: "Wöchentlich" },
    { weeks: 2, label: "14-tägig" },
    { weeks: 4, label: "Alle 4 Wochen" },
    { weeks: 8, label: "Alle 8 Wochen" },
    { weeks: 13, label: "Quartalsweise (13 Wochen)" },
    { weeks: 26, label: "Halbjährlich (26 Wochen)" },
    { weeks: 52, label: "Jährlich (52 Wochen)" },
] as const

export const intervalSelectValue = (weeks: number) => {
    const value = Math.max(1, Number(weeks) || 1)
    return SERVICE_INTERVAL_OPTIONS.some((item) => item.weeks === value) ? String(value) : String(SERVICE_INTERVAL_OPTIONS[0].weeks)
}

export function intervalLabel(weeks: number): string {
    const value = Math.max(1, Number(weeks) || 1)
    const preset = SERVICE_INTERVAL_OPTIONS.find((item) => item.weeks === value)
    if (preset) return preset.label
    return value === 1 ? "Wöchentlich" : `Alle ${value} Wochen`
}
